
import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import { useTheme } from "@/contexts/ThemeContext";

const Layout = () => {
  const { theme } = useTheme();
  const location = useLocation();
  const isLightMode = theme === 'light';
  
  // Check if we're on the settings page for full-width layout
  const isSettingsPage = location.pathname === '/settings';
  
  if (isSettingsPage) {
    return (
      <div className={`min-h-screen w-full ${isLightMode ? 'text-gray-800' : 'text-dashboard-text-primary'} font-opensans`}>
        <Sidebar defaultActiveTab="kol-tracker" />
        <main className="w-full">
          <Outlet />
        </main>
      </div>
    );
  }
  
  return (
    <div className={`flex flex-col h-screen ${isLightMode ? 'text-gray-800' : 'text-dashboard-text-primary'} font-opensans`}>
      <Sidebar defaultActiveTab="kol-tracker" />
      <main className="flex-1 overflow-auto p-4">
        <Outlet />
      </main>
    </div>
  );
};

export default Layout;
